import {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
  TEXT_DECORATION,
} from '@/bit/components/components.text';

export const productPriceItemTypes = {
  detailRecurringPrice: 'detail-recurring-price',
  detailOneTimePrice: 'detail-one-time-price',
  summaryRecurringPrice: 'summary-recurring-price',
  summaryOneTimePrice: 'summary-one-time-price',
  summaryTradeInPrice: 'summary-trade-in-price',
  detailRecurringPriceCoverageModal: 'detail-recurring-price-coverage-modal',
  detailOneTimePriceCoverageModal: 'detail-one-time-price-coverage-modal',
};
export const sizes = {
  [productPriceItemTypes.detailRecurringPrice]: {
    textName: TEXT_SIZE.CAPTION1,
    textPrice: TEXT_SIZE.CAPTION1,
    textPromotion: TEXT_SIZE.CAPTION1,
    textPromotionPrice: TEXT_SIZE.CAPTION1,
  },
  [productPriceItemTypes.detailOneTimePrice]: {
    textName: TEXT_SIZE.CAPTION2,
    textPrice: TEXT_SIZE.CAPTION2,
    textPromotion: TEXT_SIZE.CAPTION2,
    textPromotionPrice: TEXT_SIZE.CAPTION2,
  },
  [productPriceItemTypes.summaryRecurringPrice]: {
    textName: TEXT_SIZE.CAPTION1,
    textPrice: TEXT_SIZE.CAPTION1,
    textPromotion: TEXT_SIZE.CAPTION2,
    textPromotionPrice: TEXT_SIZE.CAPTION2,
  },
  [productPriceItemTypes.summaryOneTimePrice]: {
    textName: TEXT_SIZE.CAPTION1,
    textPrice: TEXT_SIZE.CAPTION1,
    textPromotion: TEXT_SIZE.CAPTION2,
    textPromotionPrice: TEXT_SIZE.CAPTION2,
  },
  [productPriceItemTypes.summaryTradeInPrice]: {
    textName: TEXT_SIZE.CAPTION1,
    textPrice: TEXT_SIZE.TITLE5,
    textMaxPriceInfo: TEXT_SIZE.TITLE5,
    textMaxPrice: TEXT_SIZE.TITLE5,
    textPromotion: TEXT_SIZE.CAPTION2,
    textPromotionPrice: TEXT_SIZE.CAPTION2,
    textInfo: TEXT_SIZE.CAPTION2,
  },
  [productPriceItemTypes.detailRecurringPriceCoverageModal]: {
    textName: TEXT_SIZE.CAPTION2,
    textPrice: TEXT_SIZE.CAPTION2,
    textPromotion: TEXT_SIZE.CAPTION2,
    textPromotionPrice: TEXT_SIZE.CAPTION2,
  },
  [productPriceItemTypes.detailOneTimePriceCoverageModal]: {
    textName: TEXT_SIZE.CAPTION2,
    textPrice: TEXT_SIZE.CAPTION2,
    textPromotion: TEXT_SIZE.CAPTION2,
    textPromotionPrice: TEXT_SIZE.CAPTION2,
  },
};
export const fontTypes = {
  [productPriceItemTypes.detailRecurringPrice]: {
    textName: TEXT_FONT_WEIGHT.BOLD,
    textPrice: TEXT_FONT_WEIGHT.REGULAR,
    textPromotion: TEXT_FONT_WEIGHT.REGULAR,
    textPromotionPrice: TEXT_FONT_WEIGHT.REGULAR,
  },
  [productPriceItemTypes.detailOneTimePrice]: {
    textName: TEXT_FONT_WEIGHT.REGULAR,
    textPrice: TEXT_FONT_WEIGHT.REGULAR,
    textPromotion: TEXT_FONT_WEIGHT.REGULAR,
    textPromotionPrice: TEXT_FONT_WEIGHT.REGULAR,
  },
  [productPriceItemTypes.summaryRecurringPrice]: {
    textName: TEXT_FONT_WEIGHT.BOLD,
    textPrice: TEXT_FONT_WEIGHT.BOLD,
    textPromotion: TEXT_FONT_WEIGHT.REGULAR,
    textPromotionPrice: TEXT_FONT_WEIGHT.REGULAR,
  },
  [productPriceItemTypes.summaryOneTimePrice]: {
    textName: TEXT_FONT_WEIGHT.BOLD,
    textPrice: TEXT_FONT_WEIGHT.BOLD,
    textPromotion: TEXT_FONT_WEIGHT.BOLD,
    textPromotionPrice: TEXT_FONT_WEIGHT.BOLD,
  },
  [productPriceItemTypes.summaryTradeInPrice]: {
    textName: TEXT_FONT_WEIGHT.BOLD,
    textPrice: TEXT_FONT_WEIGHT.BOLD,
    textPromotion: TEXT_FONT_WEIGHT.REGULAR,
    textPromotionPrice: TEXT_FONT_WEIGHT.REGULAR,
    textInfo: TEXT_FONT_WEIGHT.REGULAR,
  },
  [productPriceItemTypes.detailRecurringPriceCoverageModal]: {
    textName: TEXT_FONT_WEIGHT.BOLD,
    textPrice: TEXT_FONT_WEIGHT.BOLD,
    textPromotion: TEXT_FONT_WEIGHT.BOLD,
    textPromotionPrice: TEXT_FONT_WEIGHT.BOLD,
  },
  [productPriceItemTypes.detailOneTimePriceCoverageModal]: {
    textName: TEXT_FONT_WEIGHT.REGULAR,
    textPrice: TEXT_FONT_WEIGHT.REGULAR,
    textPromotion: TEXT_FONT_WEIGHT.REGULAR,
    textPromotionPrice: TEXT_FONT_WEIGHT.REGULAR,
  },
};
export const colors = {
  [productPriceItemTypes.detailRecurringPrice]: {
    textName: TEXT_COLOR.GREY6,
    textPrice: TEXT_COLOR.GREY5,
    textPromotion: TEXT_COLOR.RED_DARK,
    textPromotionPrice: TEXT_COLOR.RED_DARK,
    textInfo: TEXT_COLOR.GREY5,
  },
  [productPriceItemTypes.detailOneTimePrice]: {
    textName: TEXT_COLOR.GREY5,
    textPrice: TEXT_COLOR.GREY5,
    textPromotion: TEXT_COLOR.RED_DARK,
    textPromotionPrice: TEXT_COLOR.RED_DARK,
  },
  [productPriceItemTypes.summaryRecurringPrice]: {
    textName: TEXT_COLOR.BLUE_DARK,
    textPrice: TEXT_COLOR.BLUE_DARK,
    textPromotion: TEXT_COLOR.GREY5,
    textPromotionPrice: TEXT_COLOR.GREY5,
  },
  [productPriceItemTypes.summaryOneTimePrice]: {
    textName: TEXT_COLOR.BLUE_DARK,
    textPrice: TEXT_COLOR.BLUE_DARK,
    textPromotion: TEXT_COLOR.RED_DARK,
    textPromotionPrice: TEXT_COLOR.RED_DARK,
  },
  [productPriceItemTypes.summaryTradeInPrice]: {
    textName: TEXT_COLOR.BLUE_DARK,
    textPrice: TEXT_COLOR.BLUE_DARK,
    textPromotion: TEXT_COLOR.GREY5,
    textPromotionPrice: TEXT_COLOR.GREY5,
    textInfo: TEXT_COLOR.GREY5,
  },
  [productPriceItemTypes.detailRecurringPriceCoverageModal]: {
    textName: TEXT_COLOR.GREY6,
    textPrice: TEXT_COLOR.GREY6,
    textPromotion: TEXT_COLOR.RED_DARK,
    textPromotionPrice: TEXT_COLOR.RED_DARK,
  },
  [productPriceItemTypes.detailOneTimePriceCoverageModal]: {
    textName: TEXT_COLOR.GREY5,
    textPrice: TEXT_COLOR.GREY5,
    textPromotion: TEXT_COLOR.RED_DARK,
    textPromotionPrice: TEXT_COLOR.RED_DARK,
  },
};
export const decorations = {
  [productPriceItemTypes.detailRecurringPrice]: {
    textPrice: TEXT_DECORATION.LINE_THROUGH,
    textPromotionPrice: TEXT_DECORATION.NONE,
  },
  [productPriceItemTypes.detailOneTimePrice]: {
    textPrice: TEXT_DECORATION.NONE,
    textPromotionPrice: TEXT_DECORATION.NONE,
  },
  [productPriceItemTypes.summaryRecurringPrice]: {
    textPrice: TEXT_DECORATION.NONE,
    textPromotionPrice: TEXT_DECORATION.NONE,
  },
  [productPriceItemTypes.summaryOneTimePrice]: {
    textPrice: TEXT_DECORATION.NONE,
    textPromotionPrice: TEXT_DECORATION.NONE,
  },
  [productPriceItemTypes.summaryTradeInPrice]: {
    textPrice: TEXT_DECORATION.NONE,
    textPromotionPrice: TEXT_DECORATION.NONE,
  },
  [productPriceItemTypes.detailRecurringPriceCoverageModal]: {
    textPrice: TEXT_DECORATION.LINE_THROUGH,
    textPromotionPrice: TEXT_DECORATION.NONE,
  },
  [productPriceItemTypes.detailOneTimePriceCoverageModal]: {
    textPrice: TEXT_DECORATION.NONE,
    textPromotionPrice: TEXT_DECORATION.NONE,
  },
};
